import { attach, combine, createEffect, createEvent, createStore, sample, split, createApi } from 'effector'
import { Status } from './lib/lib'
import { StepId } from '../lib/utils'
import { verficarEmailSchema } from './verificar-email.schema'
import {
  executeStepFx,
  stepChanged,
  $codeExpirationTime,
  $emailVerified,
  // $user,
  // $oldEmail,
  $userId,
} from '../onboarding.model'
import dayjs from 'dayjs'

export const emailChanged = createEvent()
export const emailCleared = createEvent()
export const emailSubmitted = createEvent()
export const statusChanged = createEvent()

export const $status = createStore(Status.IDLE)
export const $value = createStore('')
export const $error = createStore(null)
export const $disabled = createStore(false)

const $body = combine([$value, $userId], ([value, userId]) => ({
  step: StepId.VERIFY_EMAIL,
  payload: {
    email: value,
    weid: +userId,
  },
}))

export const validateEmailFx = createEffect(async (email) => await verficarEmailSchema.validate({ email }))

export const sendEmailFx = attach({
  source: $body,
  effect: executeStepFx,
})

$value.reset(emailCleared)
$error.reset(emailCleared)
$status.reset(emailCleared)

$value.on(emailChanged, (_, value) => value)
// $disabled.on(statusChanged, (_, status) => status !== Status.VALID)
$disabled.on(statusChanged, (_, status) => {
  return [Status.INVALID, Status.EXPIRED, Status.ALREADY_EXISTS].includes(status)
})
$status.on(statusChanged, (_, status) => status)

// Enviar email
sample({
  clock: emailSubmitted,
  target: sendEmailFx,
})

split({
  source: sendEmailFx.failData,
  match: {
    exists: (error) => {
      return error.code === 'ALREADY_EXISTS'
    },
    internal: (error) => error.code === 'INTERNAL_ERROR',
  },
  cases: createApi($status, {
    exists: () => Status.ALREADY_EXISTS,
    internal: () => Status.INTERNAL_ERROR,
  }),
})

sample({
  clock: sendEmailFx.failData,
  filter: (error) => error.code === 'ALREADY_EXISTS',
  fn: (error) => ({
    title: 'Correo electrónico ya registrado',
    message: error.message || 'Este correo ya está en uso. Intenta con otro.',
  }),
  target: $error,
})

sample({
  clock: sendEmailFx.failData,
  filter: (error) => error.code === 'INTERNAL_ERROR',
  fn: (error) => ({
    title: 'Error interno',
    message: error.message || 'Ocurrió un error interno. Por favor, intente nuevamente.',
  }),
  target: $error,
})

sample({
  clock: sendEmailFx.pending,
  fn: () => true,
  target: $disabled,
})

sample({
  clock: sendEmailFx.done,
  fn: () => StepId.VERIFICATION_CODE,
  target: stepChanged,
})

sample({
  clock: sendEmailFx.fail,
  fn: () => false,
  target: $disabled,
})

sendEmailFx.done.watch(() => {
  $codeExpirationTime.setState(dayjs().add(30, 'minute').toISOString())
  $emailVerified.setState($value.getState())
})

// Validar email
sample({
  clock: emailChanged,
  filter: (value) => value !== '',
  target: validateEmailFx,
})

sample({
  clock: validateEmailFx.failData,
  fn: (error) => ({ title: 'Email Inválido', message: error.message }),
  target: $error,
})

// Actualizar status
sample({
  clock: emailChanged,
  filter: (value) => value === '',
  fn: () => Status.IDLE,
  target: statusChanged,
})

sample({
  clock: validateEmailFx.fail,
  fn: () => Status.INVALID,
  target: statusChanged,
})

sample({
  clock: validateEmailFx.done,
  fn: () => Status.VALID,
  target: statusChanged,
})
